import React from "react";
import { FileText, Users, HeartPulse, Wallet, Siren, Sparkles } from "lucide-react";
import landing from "@/content/landing";
import { Section } from "./HeroSection";

const ICONS = {
  dokumente: FileText,
  familie: Users,
  vorsorge: HeartPulse,
  finanzen: Wallet,
  notfall: Siren,
  wuensche: Sparkles,
};

export default function StoryGrid() {
  const t = landing.story;
  return (
    <Section id="story" className="bg-white" data-testid="landing-story">
      <div className="max-w-3xl">
        <div className="ag-overline mb-4">Warum es zählt</div>
        <h2 className="font-serif text-3xl leading-tight text-ag-ink sm:text-4xl lg:text-5xl">
          {t.headline}
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-700 sm:text-[17px]">
          {t.intro}
        </p>
      </div>

      <ul className="mt-12 grid grid-cols-2 gap-3 sm:mt-16 sm:grid-cols-3 sm:gap-4 lg:gap-6">
        {t.items.map((item) => {
          const Icon = ICONS[item.key] || FileText;
          return (
            <li
              key={item.key}
              className="ag-premium-card flex flex-col items-start gap-4 p-5 sm:p-6"
              data-testid={`landing-story-item-${item.key}`}
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-amber-100 to-amber-200 text-amber-700 shadow-inner" aria-hidden="true">
                <Icon className="h-5 w-5" strokeWidth={1.6} />
              </span>
              <div className="font-serif text-lg text-ag-ink">{item.label}</div>
            </li>
          );
        })}
      </ul>
    </Section>
  );
}
